<template>
    <v-app class="finger-guns">
      <v-app-bar
        app
        color="white"
        height="100"
      >
        <v-avatar
          class="mr-3"
          color="grey lighten-5"
          size="70"
        >

              <v-img
              contain
              max-height="70%"
              src="https://emoji.slack-edge.com/TCD1KRJS1/ds-whiz-bang/d90d6bf48efc3e84.gif"
              ></v-img>

        </v-avatar>

        <v-toolbar-title class="font-weight-black headline">
          #ds-devops
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon><v-icon>mdi-volume-mute</v-icon></v-btn>
      </v-app-bar>

      <v-dialog
        class="finger-guns"
        v-model="dialog"
        width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="red lighten-2"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Click Me
          </v-btn>
        </template>

        <v-card>
          <v-card-title class="headline text-wrap">
            Would you like to set Microsoft Edge as your default browser?
          </v-card-title>
          <v-img
              :src="require('./assets/edge.jpg')"
          ></v-img>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              depressed
              block
              large
              @click="acceptDialog"
            >
              Hurt
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-content>
        <section id="hero">
            <v-row>
              <v-col cols="4" offset="4">
                  <v-img :src="require('./assets/happy_bday_clipart_2.jpg')"></v-img>
              </v-col>
            </v-row>
        </section>

        <section id="about-me">
            <v-row class="pa-1">
              <v-col
                  v-for="emoji in jsalEmojis"
                  :key="emoji"
                  class="d-flex child-flex"
                  cols="2"
                  >
                  <v-img :src="emoji"></v-img>
              </v-col>
            </v-row>
        </section>

        <section id="stats" class="pa-12">
            <v-row>
              <v-col
                  class="d-flex child-flex"
                  cols="8"
                  offset="2"
                  >
                  <v-img src="https://emoji.slack-edge.com/TCD1KRJS1/thanks-i-hate-it/08c1a1163d3098a5.png"></v-img>
              </v-col>
            </v-row>

        </section>

        <section id="blog"></section>

        <section id="team"></section>

        <v-sheet></v-sheet>
      </v-content>

      <v-footer
        class="justify-center"
        color="#292929"
        height="100"
      >
        <div class="title font-weight-light grey--text text--lighten-1 text-center">
          &copy; {{ (new Date()).getFullYear() }} — #ds-devops
        </div>
      </v-footer>

      <audio autoplay ref="happyBday">
          <source :src="require('./assets/happy_bday_recorder.mp3')" type="audio/mpeg" />
      </audio>

      <div ref="addMoreAudioHere">
      </div>
  </v-app>
</template>

<script>
import shuffle from 'lodash/shuffle';

export default {
  name: 'HappyBdayJsal',
  methods: {
      acceptDialog() {
        this.dialog = false;
        this.$refs.happyBday.play()
      }
  },
  data () {
      return {
          dialog: true,
          emojis: [
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal/e793b99568656ea2.jpg',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-tear/3c063710f81ad531.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-thug/a8d7b070f9706dea.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-muse/53240dbe3649095e.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-friend/f99395335a367af2.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-starry/3fe6ee4a578171dc.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-peak-focus/d9ab3cc765832292.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jsal-empty-inside/bc047f22ae9a5653.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/papa-jsal/d67ee1d0c95226ae.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/mystery-jsal/684c39ad5223a92e.jpg',
              'https://emoji.slack-edge.com/TCD1KRJS1/sleeping-jsal/d1f8cee838ecc37e.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/hippo-birdy-jsal/fb24940601a8fa07.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/the-creation-of-jsal/6aa405ffeb6e0f4d.jpg',
              'https://emoji.slack-edge.com/TCD1KRJS1/jameses/8dc6d6c0b2f392c9.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/jamesjenkins/5414cf88d19b7da5.jpg',
              'https://emoji.slack-edge.com/TCD1KRJS1/james_is_the_whiz/f95056d3151ed1bc.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/smoothjazzjames/8992ae7e673df276.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/terminator-james/0db55ca177957c71.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/tv_james/5f1365defa6bebb6.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/tv_james_2/d1cad54f886351db.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/tv_james_3/df8150faaa02c8dd.jpg',
              'https://emoji.slack-edge.com/TCD1KRJS1/tv_james_4/197cb5c473206114.png',
              'https://emoji.slack-edge.com/TCD1KRJS1/tv_james_5/8a8001af8378dd61.png'
          ]
      }
  },
  computed: {
      jsalEmojis() {
          return shuffle(this.emojis)
      }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

.finger-guns {
  cursor: url('./assets/finger-guns.png'), auto !important;
}
</style>
